export enum LocalStorageKey {
  ASSESSMENT_PASTE_INFO = 'envigo_assesment_paste_info',
}
